
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14.642 15.968"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Settings_","data-name":"Settings","transform":"translate(-209.035 -714)","fill":"none","stroke":"#5a677d","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_20322","data-name":"Path 20322","d":"M86.3 6.031a1.952 1.952 0 101.951 1.951A1.951 1.951 0 0086.3 6.031z","transform":"translate(130 714)"}}),_c('path',{attrs:{"id":"Path_20323","data-name":"Path 20323","d":"M91.9 9.128l-.267-.155a5.5 5.5 0 000-1.982l.267-.155a1.807 1.807 0 00-1.8-3.132l-.268.154a5.425 5.425 0 00-1.719-.989v-.312a1.808 1.808 0 00-3.615 0v.31a5.425 5.425 0 00-1.718.991L82.5 3.7a1.808 1.808 0 10-1.8 3.133l.267.155a5.456 5.456 0 000 1.982l-.267.16a1.809 1.809 0 101.8 3.137l.268-.155a5.412 5.412 0 001.718.989v.309a1.807 1.807 0 103.615 0v-.31a5.43 5.43 0 001.719-.991l.269.155a1.808 1.808 0 001.8-3.133z","transform":"translate(130 714)"}})])])
          )
        }
      }
    